import { Fragment, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { creatorCurvesActions, settingsCurvesActions } from 'actions/curves';
import { CurvesUtils } from 'utils';

import BasketNew from 'primary/Basket';
import BasketHeader from 'primary/BasketHeader';
import FormulaAdded from 'primary/FormulaAdded';
import TooLongWarn from 'primary/TooLongWarn';
import CurveSettings from './CurveSettings';
import DataTab from './DataTab';

import { When } from 'react-if';

const emptyArray = []
const COUNTER_LABEL = "added"
const BasketLocal = () => {
  const dispatch = useDispatch(),
        [addressLocal, setAddressLocal] = useState(),
        isBasketOpen = useSelector(state => state.curvesState.creatorState.isBasketOpen),
        showTooLongFormula = useSelector(state => state.curvesState.creatorState.showTooLongFormula),
        address = useSelector(state => state.curvesState.creatorState.address),
        selectedCurves = useSelector(state => state.curvesState.creatorState.selectedCurves) || emptyArray,
        selectedColumns = useSelector(state => state.curvesState.creatorState.selectedColumns) || emptyArray,
        swapIsOpen = useCallback(() => dispatch(creatorCurvesActions.onChange(!isBasketOpen, "isBasketOpen")), [dispatch, isBasketOpen]),
        addToSheet = useCallback(async () => dispatch(creatorCurvesActions.addToSheet(setAddressLocal)), [dispatch]),
        onReset = useCallback(() => {
          dispatch(creatorCurvesActions.clear())
          dispatch(settingsCurvesActions.clear())
        }, [dispatch]),
        onClearSelected = useCallback(() => dispatch(creatorCurvesActions.onChange([], "selectedCurves")), [dispatch]),
        onChangeColumns = useCallback(value => dispatch(creatorCurvesActions.onChange(value, "selectedColumns")), [dispatch]),
        hideWarns = useCallback(() => dispatch(creatorCurvesActions.onChange(false, "showTooLongFormula")), [dispatch]),
        closeFormulaAdded = useCallback(() => setAddressLocal(), []),
        onEdit = useCallback(async () => await Excel.run(context => {
          const cell = context.workbook.worksheets
            .getActiveWorksheet()
            .getRange(addressLocal);
          cell.load("formulas");
          cell.load("address");
          return context.sync().then(async () => {
              const formula = cell.formulas?.[0]?.[0],
                    curveParsed = await CurvesUtils.validateTable({
                      cell,
                      formula,
                      returnItem: true
                    })
              if(curveParsed) {
                const groupedParams = curveParsed.parsedParameters.getGroupedParams()
                dispatch(creatorCurvesActions.editFormula({ 
                  address: curveParsed.address, 
                  keys: groupedParams,
                  ...curveParsed.parsedParameters
                }))
                closeFormulaAdded()
              }
          })
        }), [addressLocal, closeFormulaAdded, dispatch])

  useEffect(() => {
    if(addressLocal) {
      onReset()
    }
  }, [addressLocal, onReset])

  return (
    <Fragment>
      <When condition={addressLocal}>
        {() => (
          <FormulaAdded
              addressLocal={addressLocal}
              onClose={closeFormulaAdded}
              onEdit={onEdit}
          />
        )}
      </When>
      <BasketHeader
          addToSheet={addToSheet}
          counterLabel={COUNTER_LABEL}
          onChangeColumns={onChangeColumns}
          onClearSelected={onClearSelected}
          onConfigure={swapIsOpen}
          onReset={onReset}
          selectedColumns={selectedColumns}
          selectedItems={selectedCurves}
          withPattern={false}
          withSelect={false}
          />
      <BasketNew
          address={address}
          addToSheet={addToSheet}
          counterLabel={COUNTER_LABEL}
          dataTab={<DataTab/>}
          isBasketOpen={isBasketOpen}
          onClearSelected={onClearSelected}
          onReset={onReset}
          selectedItems={selectedCurves}
          settings={<CurveSettings/>}
          swapIsOpen={swapIsOpen}
      />
      <When condition={showTooLongFormula}>
        {() => (
          <TooLongWarn onClose={hideWarns}/>
        )}
      </When>
    </Fragment>
  )
}
export default BasketLocal;